module.exports = __webpack_public_path__ + "static/emm-002-59d3b9c7dd62267006ef16c17bd34f24.jpg";